export const HOST = "https://myzone-system.uz"
